// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsSortMenu-wrapper-44edb714d748d1ddea4c4a598e0afe34","sortLabel":"ReportsSortMenu-sortLabel-3a66cb1f5bf63d22df76885a9bd0e654"};